import React from "react";
import { withRouter } from "react-router-dom";
import {
  addressARedIcon,
  addressBRedIcon,
  addressCRedIcon,
  addressDRedIcon,
  addressERedIcon,
  addressFRedIcon,
  dateIconImage,
  editImage,
  iconn,
  timeIconImage,
} from "../../../../../assets";
import {
  getStatusForCustomer,
  getStatusForDirectRequest,
  time_convert,
} from "../../../../../ui_libs/Functions/functions";
import { PendingAcceptance } from "./components";
function RequestInformation(props) {
  const {
    id,
    request_timeline_status,
    s_time,
    s_date,
    recommend_amount,
    customer_budget,
    request_status,
    discount,
    request_type,
  } = props.request.request;

  const { request_address } = props.request;
  console.log(props.request, "Single Request");
  const addressIcon = (i) => {
    return i === 0
      ? addressARedIcon
      : i === 1
      ? addressBRedIcon
      : i === 2
      ? addressCRedIcon
      : i === 3
      ? addressDRedIcon
      : i === 4
      ? addressERedIcon
      : addressFRedIcon;
  };
  return (
    <>
      <div className="req-id-status-wrapper pb-2 pb-sm-3 border-bottom">
        <div className="row">
          <div className="col-10 font-weight-bold">#{id}</div>
          <div className="col-2 text-right">
            {request_status !== 2 && (
              <img
                className="pointer-point"
                onClick={() =>
                  props.history.push(`/dashboard/my-requests/${id}`)
                }
                src={editImage}
              />
            )}
          </div>
        </div>
      </div>
      <div>
        <div className="request-info pt-2 pt-sm-3 pb-sm-1 ">
          {request_timeline_status === 1 && (
            <PendingAcceptance requestData={props.request} />
          )}
          <div className="row req-date-time-info no-gutters pb-2">
            <div className="col-12 col-sm-6 col-md-5 col-lg-5 black-grey-color pb-3">
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="5" cy="5" r="5" fill="#C4314B" />
              </svg>{" "}
              {request_type
                ? props.request.additional_status === 0 &&
                  request_timeline_status === 3
                  ? "Pending request confirmation"
                  : getStatusForDirectRequest(request_timeline_status)
                : getStatusForCustomer(request_timeline_status)}
            </div>
            <div className="col-12 col-sm-6 col-md-7 col-lg-7 req-date-time-info-box mb-0">
              <div className="row no-gutters">
                <div className="col-12 col-sm-6 pb-2">
                  <img className="pr-2" src={dateIconImage} />
                  {/* {schedule_time.slice(0, 11)} */}
                  {s_date}
                </div>
                <div className="col-12 col-sm-6 pb-2 req-info-text">
                  <img src={timeIconImage} className="pr-2" />
                  {/* {`${time_convert(s_time.slice(0,5))} to ${time_convert(s_time.slice(8,13))}`} */}
                  {s_time && s_time !== "8AM - 12PM Morning" &&
                    s_time !== "12PM - 5PM Evening" &&
                    s_time !== "Entire day" &&
                    `${time_convert(
                      s_time.split('-')[0].trim()
                    )} to ${time_convert(s_time.split('-')[1].trim())}`}
                  {s_time && (s_time == "8AM - 12PM Morning" ||
                    s_time == "12PM - 5PM Evening" ||
                    s_time == "Entire day") && `${s_time}`}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="request-detail-price-wrapper">
          <div className="row">
            {!request_type && (
              <div className="col-12 col-sm-6 col-md-5 col-lg-4">
                <span className="small-font-size dark-grey-color overline">
                  Estimated price:
                </span>
                <span className="font-weight-bold pl-3">
                  ${recommend_amount}
                </span>
              </div>
            )}

            {!request_type && (
              <div className="col-12 col-sm-6 col-md-5 col-lg-4">
                <span className="small-font-size dark-grey-color overline">
                  Your price:
                </span>
                <span className="font-weight-bold pl-3">
                  ${customer_budget}
                </span>
              </div>
            )}
            {parseInt(discount) > 0 && (
              <div className="col-12 col-sm-6 col-md-5 col-lg-4 ">
                <span className="small-font-size dark-grey-color overline">
                  Discount:
                </span>
                <span className="font-weight-bold pl-3">{discount}%</span>
              </div>
            )}
          </div>
        </div>
        <div
          className={
            request_timeline_status > 0
              ? "request-address-wrapper pt-3 pt-sm-4 border-bottom"
              : "request-address-wrapper pt-3 pt-sm-4 "
          }
        >
          <div className="row">
            {request_address.map((address, i) => (
              <div key={i} className="col-12 col-sm-6 pb-2 ">
                <div className="rounded-box p-3">
                  <div className="address-pin-zipcode">
                    <span>
                      <img src={addressIcon(i)} />
                    </span>
                    <span className="black-color pl-1">
                      {address.complete_address}
                    </span>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-lg-6">
                      <div className="pt-2">
                        <span className="dark-grey-color small-sub-title">
                          Zip:{" "}
                        </span>
                        <span className="black-color small-font-size pl-3">
                          {address.zip_code}
                        </span>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-lg-6">
                      <div className="pt-2 row">
                        <div className="col-12">
                          <span className="dark-grey-color small-sub-title ">
                            Unit or Ap. number:{" "}
                          </span>
                          <span className="black-color small-font-size pl-3 ">
                            {address.apartment_number
                              ? address.apartment_number
                              : "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-lg-6">
                      <div className="pt-2">
                        <span className="dark-grey-color small-sub-title">
                          Storage:
                        </span>
                        <span className="black-color small-font-size pl-3">
                          {address.is_storage ? "Yes" : "No"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(RequestInformation);
